import React, { useState } from 'react';
import ConfirmModal from "./ConfirmModal";
import ConfirmModalLogout from "./ConfirmModalLogout";
import logoWhite from "../img/logo_ritelia.png";

const NavBar = ({username, logout}) => {
    const [isModalOpen, setIsModalOpen] = useState(false)

    const handleSubmit = () => {
        logout();
    }

    return (
      <nav className="navbar navbar-dark  navbar-expand-lg" style={{ width:"100%", backgroundColor: '#1F1F39!important',marginBottom: 10, justifyContent: 'space-between', padding: '10px'}}>
          <div>
              <img
                  src={logoWhite}
                  style={{width:'100px'}}
                  />
          </div>
          {username!=="" && <span className="navbar-text">
              Hola {username} - <a href="#" onClick={() => setIsModalOpen(true)}>Salir</a>
            </span>}
          <ConfirmModalLogout
            isOpen={isModalOpen}
            onConfirm={handleSubmit}
            onClose={() => setIsModalOpen(false)}
          />
      </nav>
  );
};
export default NavBar;